import React from "react";
import {
  TextField,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  Dialog,
} from "@material-ui/core";
import useLanguage from "../hooks/useLanguage";

function FormModal({ show, onHide, error, addArticle }) {
  const { language } = useLanguage();
  const { translate } = language;
  function submitForm(e) {
    e.preventDefault();
    addArticle(e.target.name.value);
    onHide();
  }

  return (
    <Dialog open={show} onClose={onHide} aria-labelledby="form-dialog-title">
      <form onSubmit={(e) => submitForm(e)}>
        <DialogTitle>{translate.new_article}</DialogTitle>
        <DialogContent>
          <TextField
            id="name"
            name="name"
            label={translate.article_name}
            autoFocus
            fullWidth
          />
          {error && <DialogContentText>{error}</DialogContentText>}
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default FormModal;
